<!-- 销售单模板 -->
<template>
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog  title="选择销销售单"  :visible.sync="dialogVisible"  width="90%" append-to-body top="2rem" center>
			<div class='components_content_box'>
				<div class="page_content_top">
					<div class="page_content_top_line">
						<el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData[0]" size="mini">
							<el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in pageShowData[0].jurconfigform" :key="formOneKey">
								
								<!-- 业务员	 -->
								<el-select filterable  v-if="formOneValue.entityField == 'woamSalesman'" v-model="getRequestData[formOneValue.entityField]">
									<el-option label="全部" value="">
									</el-option>
									<el-option v-for="(values,keys) in userOneList" :key="keys" :label="values.opmName" :value="values.opmId">
									</el-option>
								</el-select>
								
								<!-- 销往单位/客户	 -->
								<el-input v-else-if="formOneValue.entityField == 'woamSalecus'" v-model.trim="getRequestData.cmName" clearable 
									@focus="$refs['showSelectData'].openBox('customerList','customerList','cmId')">
								</el-input>
								
								<el-input v-else  v-model.trim="getRequestData[formOneValue.entityField]" size="mini" :maxlength="$store.state.inputLength"></el-input>
								
							</el-form-item>
							<el-form-item>
								<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div class="page_content_center">
					<el-table  v-if="pageShowData[1]" stripe :data="returnData.list" @row-dblclick="selectDataAction"  height="500" border style="width: 100%" highlight-current-row>
						<el-table-column type="expand" label="其它信息"  width="100">
						    <template slot-scope="props">
								<el-tabs type="border-card">
									<el-tab-pane v-if="pageShowData[2]" :label="pageShowData[2].jciName">
										<el-table :data="[props.row.desuWosupinforAdd]"  border style="width: 100%">
											<el-table-column
												v-if="tableValye.isShow==1" 
												v-for="(tableValye,tableKey) in pageShowData[2].jurconfigtable" 
												:key="tableKey" 
												:prop="tableValye.entityField"  
												:label="tableValye.showField"  >
												<template  slot-scope="scope">
													<div v-if="tableValye.entityField == 'woamSaledate'">
														<div v-if="scope.row[tableValye.entityField]">
															{{$common.getLocalTime(scope.row[tableValye.entityField])}}
														</div>
													</div>
													<div v-else>
														{{scope.row[tableValye.entityField]}}
													</div>
												</template>
											</el-table-column>
										</el-table>
									</el-tab-pane>
									<el-tab-pane v-if="pageShowData[3]" :label="pageShowData[3].jciName">
										<el-table  :data="props.row.woApplyDetails"  border  style="width: 100%">
											<el-table-column type="expand" label="赠品信息"  width="100">
												<template  slot-scope="scope">
													<el-table border  style="width: 100%;"  :data="scope.row.desuWoapplygiftAdd == null ? [] :[scope.row.desuWoapplygiftAdd]">
														<el-table-column  prop="giftBgmName" label="赠品名字"></el-table-column>
														<el-table-column  prop="giftBgmManufacturer" label="生产厂家"></el-table-column>
														<el-table-column  prop="giftBgmPlaceorigin" label="产地"></el-table-column>
														<el-table-column  prop="giftBgmSpecifications" label="规格"></el-table-column>
														<el-table-column  prop="giftNum" label="赠品数量"></el-table-column>
													</el-table>
												</template>
											</el-table-column>
											<el-table-column
												v-if="tableValye.isShow==1" 
												v-for="(tableValye,tableKey) in pageShowData[3].jurconfigtable" 
												:key="tableKey" 
												:prop="tableValye.entityField"  
												:label="tableValye.showField"  >
												<template  slot-scope="scope">
													<div v-if="tableValye.entityField == 'woadEffdate'">
														<div v-if="scope.row[tableValye.entityField]">
															{{$common.getLocalTime(scope.row[tableValye.entityField])}}
														</div>
														
													</div>
													<div v-else-if="tableValye.entityField == 'woadProdate'">
														<div v-if="scope.row[tableValye.entityField]">
															{{$common.getLocalTime(scope.row[tableValye.entityField])}}
														</div>
													</div>
													<div v-else>
														{{scope.row[tableValye.entityField]}}
													</div>
												</template>
											</el-table-column>
										</el-table>
									</el-tab-pane>
									
									
								</el-tabs>
						    </template>
						</el-table-column>
						<el-table-column v-if="tableValye.isShow==1"
							v-for="(tableValye,tableKey) in pageShowData[1].jurconfigtable" 
							:key="tableKey" 
							:prop="tableValye.entityField"  
							:label="tableValye.showField">
							<template  slot-scope="scope">
								<div v-if="tableValye.entityField == 'woamSaledate'">
									<div v-if="scope.row[tableValye.entityField]">
										{{$common.getLocalTime(scope.row[tableValye.entityField])}}
									</div>
								</div>
								<div v-else-if="tableValye.entityField == 'woamIswmsm'">
									{{scope.row.woamIswmsm == 0 ? '否' : '是'}}
								</div>
								<div v-else>
									{{scope.row[tableValye.entityField]}}
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="page_content_bottom">
					<el-pagination
						background
						@size-change="setDataPageSize"
						@current-change="setDataPageNumber"
						:current-page="getRequestData.page"
						:page-sizes="[30,50,100,500]"
						:page-size="30"
						layout="total, sizes, prev, pager, next, jumper"
						:total="returnData.total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	name:'salesOrderTemplate',
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			dialogVisible:false,
			getRequestData:{
				woamSalesman:'',  // 业务员
				woamSalecus:'',  // 客户ID
				cmName:'', // 客户名称
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			pageShowData:[],
			userOneList:[],
			
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
		'getRequestData.cmName':{
			handler:function(newValue,oldValue){
				if(newValue==''){
					this.getRequestData.woamSalecus = ''
				}
			},
			deep:true,
		}
	},
	//方法集合
	methods: {
		// 获取业务员
		async getSpecialUser(){
			let responseData =  await this.$http.getSpecialUser({opmSalesperson:1})
			if(responseData.status == 200){
				this.userOneList = responseData.result
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		isShowData(name,value){
			switch(name){
				case 'customerList':
					var dataInfo = sessionStorage.getItem('selectCustomerData')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.getRequestData.woamSalecus = dataInfo.cmId
						this.getRequestData.cmName = dataInfo.cmName
					}
					
				break;
				
				default:
					this.getRequestData[name] = value
				
			}
			
		},
		openBox(){
			this.getPageInfo()
			this.getDataList()
			this.dialogVisible = true
		},
		selectDataAction(row, column, event){
			this.dialogVisible = false
			this.$parent.extractData(row)
		},
		// 获取数据列表
		async getPageInfo(){
			var pathId = parent.getMenuInfo('/salesOrderList')
			let responseData =  await this.$http.pageFormText({ids:[pathId.jurId]})
			if(responseData.status == 200){
				this.pageShowData = responseData.result
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.notExtractSalesOrder(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getSpecialUser()
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
